export default __webpack_public_path__ + "static/media/kusamaLogo.445b5ac3.svg";